module.exports = __webpack_public_path__ + "static/12-7f1bd1190767e68ec15191bdfab6b1ac.jpeg";